<div class="claroMiniImageButton-container" [style.background-color]="containerBkgrndColor" [ngClass]="{'is-mobile-view': isMobileView}" (click)="containerClicked()">
    <div class="claroMiniImageButton-innerContainer" [ngClass]="{'selected': isSelected, 'highlighted': isHighlighted, 'is-mobile-view': isMobileView}">
        <!-- <img class="claroMiniImageButton-image" [ngClass]="{'is-mobile-view': isMobileView}" [src]="image"> -->
        <mat-icon class="claroMiniImageButton-icon">{{image}}</mat-icon>
    </div>
</div>
